import React, { useEffect } from "react";

// Components
import { Grid } from "@mui/material";

// Styles
import { BoxContainer, FooterContainer, FooterText, ImageContainer } from "./styles";

// Utils
import { useTranslation } from "react-i18next";

export default function Footer({ open }) {
  const { t } = useTranslation();

  useEffect(() => {}, [open]);

  const currentYear = new Date().getFullYear();

  return (
    <BoxContainer open={open}>
      <FooterContainer container open={open} wrap="nowrap" id="FooterContainer">
        <Grid item sx={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
          <ImageContainer src={require("../../assets/images/SE-logo.png")} />
        </Grid>
        <Grid item sx={{ minWidth: 0, display: 'flex', alignItems: 'center' }}>
          <FooterText>{t("footer.poweredBy")} {currentYear}</FooterText>
        </Grid>
      </FooterContainer>
    </BoxContainer>
  );
}
